// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "dist/js/" + {"317":"algolia-autocomplete","462":"instantsearch"}[chunkId] + "." + {"317":"5a359f6038bc3096","462":"868befb0a0c78212"}[chunkId] + ".js";
};